// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__3Tpq4","LogoWrapper":"styles_LogoWrapper__kqgAf","SearchInput":"styles_SearchInput__3Ii7M"};